"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMBytecodeStorage = void 0;
const inversify_1 = require("inversify");
const ArrayStorage_1 = require("../ArrayStorage");
let VMBytecodeStorage = class VMBytecodeStorage extends ArrayStorage_1.ArrayStorage {
    store(bytecode) {
        const id = this.getLength();
        this.set(id, bytecode);
        return id;
    }
    getById(id) {
        return this.get(id);
    }
    getAllBytecode() {
        return this.getStorage();
    }
    clear() {
        this.storage = [];
    }
};
exports.VMBytecodeStorage = VMBytecodeStorage;
exports.VMBytecodeStorage = VMBytecodeStorage = __decorate([
    (0, inversify_1.injectable)()
], VMBytecodeStorage);
